import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import Select from 'react-select'
import Header from "../Layout/header";
import GridContainer from "../components/Grid/GridContainer.js";
import GridItem from "../components/Grid/GridItem";
import Footer from "../Layout/footer.js";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Profile from "../Assets/no_profile2.png";
import { toast } from "react-toastify";
import { getprofile, GetuserData, KycSubmit } from "../Axios/user.axios";
import PhoneInput from "react-phone-number-input";

import { isValidPhoneNumber } from "react-phone-number-input";
import { FirstCaps, ImgEmpty, ImgUrl, isEmpty } from "../helper/common";
import config from '../helper/config'

const dashboardRoutes = [];
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

const initialFormValue = {
  name: "",
  customurl: "",
  bio: "",
  twitter: "",
  photo: "",
  email: "",
  facebook: "",
  youtube: "",
  instagram: "",
  FirstName: "",
  MiddleName: "",
  LastName: "",
  Gender: "",
  DOB: null,
  EmailId: "",
  Mobile: "",
  AddressLine1: '',
  AddressLine2: '',
  City: '',
  State: '',
  Country: '',
  ZipCode: '',
  NationalId: '',
  AddressProof: '',
};

export default function Verification(props) {


  const navigate = useNavigate();
  //   const Wallet_Details = useSelector((state) => state.wallet_connect_context);
  const Wallet_Details = {};
  //   var dispatch = useDispatch();


  const { ...rest } = props;
  const [disablebtn, setDisablebtn] = useState(0);
  const [formValue, setFormValue] = useState(initialFormValue);
  const [validateError, setValidateError] = useState({});
  const [user, setUser] = useState();
  const [RefreshData, SetRefreshData] = useState(1);

  const Options = [
    {
      label: "PersonalDetails",
      value: "PersonalDetails",
    },
    {
      label: "PhysicalAddress",
      value: "PhysicalAddress",
    },
    {
      label: "BioMetric",
      value: "BioMetric",
    },
  ]

  useEffect(() => {
    let cookie = ("; " + document.cookie)
      .split(`; ${config.cookiename}=`)
      .pop()
      .split(";")[0];
    if (cookie) {
      getProfiledata(cookie);
    }
    else {
      // navigate('/login')
    }
  }, [RefreshData])

  async function getProfiledata(cookie) {
    setDisablebtn(0);
    var data = await GetuserData({ data: cookie });
    console.log('GetuserData_resp', data)
    if (data?.status) {
      setUser(data?.data)
      if (data?.data) {
        setFormValue({ ...(data?.data?.kycdata ? data?.data?.kycdata : {}) })
      }
    }
    else {
      // navigate('/login')
    }
  }

  const handleFile = (event) => {
    setValidateError({})
    setDisablebtn(0);
    event.preventDefault();
    var reader = new FileReader();
    const { id, files } = event.target;
    setDisablebtn(0);
    let formData = {
      ...formValue,
      ...{
        BioMetric: {
          ...formValue?.BioMetric,
          [id]: files[0],
        }
      }
    };
    setFormValue(formData);
  };

  const onChange = (e, name) => {
    setValidateError({})
    setDisablebtn(0);
    if (name) {
      let formData = {
        ...formValue,
        ...{
          PersonalDetails: {
            ...formValue?.PersonalDetails,
            [name]: e,
          }
        }
      };
      return setFormValue(formData);
    }
    e.preventDefault();
    const { id, value } = e.target;
    name = e?.target?.name;
    let formData = {
      ...formValue,
      ...{
        [name]: {
          ...formValue?.[name],
          [id]: value,
        },
      }
    };
    setFormValue(formData);
  };


  const handleFormSubmit = async (e) => {
    var errorcheck = await Validate(formValue);
    if (isEmpty(errorcheck)) {
      let senddata = {
        ...formValue?.[formValue?.type],
        type: formValue?.type,
      }
      let resp = await KycSubmit(senddata);
      console.log('KycSubmit_resp', resp)
      if (resp?.success == 'success') {
        setDisablebtn(3);
        setDisablebtn(0);
        setValidateError("");
        toast.success("Profile has been updated");
        // setTimeout(() => navigate("/my-items"), 1000);
        setValidateError({});
        SetRefreshData(RefreshData + 1)
      }
      else {
        setDisablebtn(1);
        if (resp?.data) {
          setValidateError(resp);
        }
        toast.error((resp?.msg ? resp?.msg : "Try Again"),);
      }
    }
    else {
      setDisablebtn(1);
      setValidateError(errorcheck);
      toast.error("Fix all Validations",1000)
    }
  };

  const Validate = async (data) => {
    var validateError = {};
    let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([A-Za-zA-Z\-0-9]+\.)+[A-Za-zA-Z]{2,}))$/;
    let imageSize = 5000000;

    if (isEmpty(data?.type)) {
      validateError.type = "Select Type";
    }
    else {
      if (data?.type == 'PersonalDetails') {
        if (isEmpty(data?.[data?.type]?.FirstName)) {
          validateError.FirstName = "First Name is Required";
        }
        else {
          if (config.naverificationmeFormat.test(data?.[data?.type]?.FirstName)) {
            validateError.FirstName = "Cannot allowed smiley";
          }
        }
        if (isEmpty(data?.[data?.type]?.MiddleName)) {
          validateError.MiddleName = "Middle Name is Required";
        }
        else {
          if (config.nameFormat.test(data?.[data?.type]?.MiddleName)) {
            validateError.MiddleName = "Cannot allowed smiley";
          }
        }
        if (isEmpty(data?.[data?.type]?.LastName)) {
          validateError.LastName = "Last Name is Required";
        }
        else {
          if (config.nameFormat.test(data?.[data?.type]?.LastName)) {
            validateError.LastName = "Cannot allowed smiley";
          }
        }
        if (isEmpty(data?.[data?.type]?.Gender)) {
          validateError.Gender = "Gender is Required";
        }
        if (isEmpty(data?.[data?.type]?.DOB)) {
          validateError.DOB = "Dat of Birth is Required";
        }
        if (isEmpty(data?.[data?.type]?.EmailId)) {
          validateError.EmailId = "Email-Id is Required";
        }
        else {
          if (!emailRegex.test(data?.[data?.type]?.EmailId)) {
            validateError.EmailId = "Enter valid Email-Id";
          }
        }
        if (isEmpty(data?.[data?.type]?.Mobile)) {
          validateError.Mobile = "Mobile Number is Required";
        }
        else if (!isValidPhoneNumber(data?.[data?.type]?.Mobile)) {
          validateError.Mobile = "Mobile Number is Required";
        }
      }
      else if (data?.type == 'PhysicalAddress') {
        if (isEmpty(data?.[data?.type]?.AddressLine1)) {
          validateError.AddressLine1 = "Address Line 1 is Required";
        }
        if (isEmpty(data?.[data?.type]?.AddressLine2)) {
          validateError.AddressLine2 = "Address Line 2 is Required";
        }
        if (isEmpty(data?.[data?.type]?.City)) {
          validateError.City = "City is Required";
        }
        if (isEmpty(data?.[data?.type]?.State)) {
          validateError.State = "State is Required";
        }
        if (isEmpty(data?.[data?.type]?.Country)) {
          validateError.Country = "Country is Required";
        }
        if (isEmpty(data?.[data?.type]?.ZipCode)) {
          validateError.ZipCode = "ZipCode is Required";
        }
      }
      else if (data?.type == 'BioMetric') {
        if (ImgEmpty(data?.[data?.type]?.NationalId)) {
          validateError.NationalId = "National Id is Required";
        }
        else if (typeof (data?.[data?.type]?.NationalId) == 'object') {
          if (imageSize < data?.[data?.type]?.NationalId.size) {
            validateError.NationalId = "File size must be below 5mb";
          }
          if (
            !/\.(jpg|JPG|jpeg|JPEG|png|PNG|webp|WEBP|gif|GIF)$/i.test(
              data?.[data?.type]?.NationalId.name
            )
          ) {
            validateError.NationalId =
              "file is invalid. only allowed JPG,PNG,WEBP,gif";
          }
        }
        if (ImgEmpty(data?.[data?.type]?.AddressProof)) {
          validateError.AddressProof = "Address Proof is Required";
        }
        else if (typeof (data?.[data?.type]?.AddressProof) == 'object') {
          if (imageSize < data?.[data?.type]?.AddressProof.size) {
            validateError.AddressProof = "File size must be below 5mb";
          }
          if (
            !/\.(jpg|JPG|jpeg|JPEG|png|PNG|webp|WEBP|gif|GIF)$/i.test(
              data?.[data?.type]?.AddressProof.name
            )
          ) {
            validateError.AddressProof =
              "file is invalid. only allowed JPG,PNG,WEBP,gif";
          }
        }
      }
      else {
        validateError.type = "Invalid Type";
      }
    }
    setValidateError(validateError);
    return validateError;
  };

  return (
    <div className="inner_header">
      <Header />
      <div className="mt-5">
        <div >
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className="d-flex align-items-center">
                <h3 className="section-head mb-0">Edit Profile</h3>
              </div>
            </GridItem>
          </GridContainer>
        </div>
        <div className="container mt-5">
          <GridContainer>
            <GridItem xs={12} sm={9} md={9}>
              <form>

                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label className="primary_label" htmlFor="name">
                      Select Type
                    </label>
                    <Select
                      options={Options}
                      onChange={(e) => {setValidateError({});setFormValue({ ...formValue, ...{ type: e.value } })}}
                    />
                    {validateError.type && (
                      <span className="text-danger">{validateError.type}</span>
                    )}

                  </div>
                </div>
                {
                  formValue?.type == "PersonalDetails" &&
                  <div>
                    Personal Details {formValue?.Verification?.PersonalDetails=="pending"?"(Waiting for Approval)": isEmpty(formValue?.Verification?.PersonalDetails) ? "" : `(${FirstCaps(formValue?.Verification?.PersonalDetails)})`}
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="name">
                          First Name
                        </label>
                        <input
                          type="text"
                          className="form-control primary_inp"
                          id="FirstName"
                          name="PersonalDetails"
                          placeholder="Enter your display name"
                          onChange={onChange}
                          value={formValue?.PersonalDetails?.FirstName ?? ''}
                        />

                        {validateError.FirstName && (
                          <span className="text-danger">{validateError.FirstName}</span>
                        )}
                      </div>
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="name">
                          Middle Name
                        </label>
                        <input
                          type="text"
                          className="form-control primary_inp"
                          placeholder="Enter unique name only... EX.Nila,Ronaldo..."
                          id="MiddleName"
                          name="PersonalDetails"
                          onChange={onChange}
                          value={formValue?.PersonalDetails?.MiddleName ?? ''}
                          defaultValue=""
                        />

                        {validateError.MiddleName && (
                          <span className="text-danger">
                            {validateError.MiddleName}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="desccription">
                          Last Name
                        </label>
                        <input
                          type="text"
                          className="form-control primary_inp"
                          id="LastName"
                          name="PersonalDetails"
                          value={formValue?.PersonalDetails?.LastName ?? ''}
                          onChange={onChange}
                          placeholder="Your email for marketplace notifications"
                        />
                        {validateError.LastName && (
                          <span className="text-danger">{validateError.LastName}</span>
                        )}
                      </div>
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="name">
                          Date of Birth
                        </label>
                        <input
                          type="date"
                          className="form-control primary_inp"
                          id="DOB"
                          name="PersonalDetails"
                          onChange={onChange}
                          value={formValue?.PersonalDetails?.DOB ?? ''}
                          placeholder="Tell about yourself in a few words"
                        />
                        {validateError.DOB && (
                          <span className="text-danger">{validateError.DOB}</span>
                        )}
                      </div>
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="name">
                          Gender
                        </label>
                        <input
                          type="text"
                          className="form-control primary_inp"
                          id="Gender"
                          name="PersonalDetails"
                          onChange={onChange}
                          value={formValue?.PersonalDetails?.Gender ?? ''}
                          placeholder="Tell about yourself in a few words"
                        />
                        {validateError.Gender && (
                          <span className="text-danger">{validateError.Gender}</span>
                        )}
                      </div>
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="name">
                          Email Address
                        </label>
                        <input
                          type="text"
                          className="form-control primary_inp"
                          id="EmailId"
                          name="PersonalDetails"
                          onChange={onChange}
                          value={formValue?.PersonalDetails?.EmailId ?? ''}
                          placeholder="Tell about yourself in a few words"
                        />
                        {validateError.EmailId && (
                          <span className="text-danger">{validateError.EmailId}</span>
                        )}
                      </div>
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="name">
                          Mobile Number
                        </label>
                        <PhoneInput
                          placeholder="Enter phone number"
                          id="Mobile"
                          onChange={(e) => onChange(e, "Mobile", "PersonalDetails")}
                          defaultCountry="US"
                          country="US"
                          countries={["US", "IN"]}
                          value={formValue?.PersonalDetails?.Mobile ?? ''}
                        />
                        {validateError.Mobile && (
                          <span className="text-danger">{validateError.Mobile}</span>
                        )}
                      </div>
                    </div>
                  </div>
                }

                {
                  formValue?.type == "PhysicalAddress" &&
                  <div>
                    Physical Address {formValue?.Verification?.PhysicalAddress=="pending"?"(Waiting for Approval)": isEmpty(formValue?.Verification?.PhysicalAddress) ? "" : `(${FirstCaps(formValue?.Verification?.PhysicalAddress)})`}
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="name">
                          Address Line 1
                        </label>
                        <input
                          type="text"
                          className="form-control primary_inp"
                          id="AddressLine1"
                          name="PhysicalAddress"
                          placeholder="Enter your display name"
                          onChange={onChange}
                          value={formValue?.PhysicalAddress?.AddressLine1 ?? ''}
                        />

                        {validateError.AddressLine1 && (
                          <span className="text-danger">{validateError.AddressLine1}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="name">
                          Address Line 2
                        </label>
                        <input
                          type="text"
                          className="form-control primary_inp"
                          id="AddressLine2"
                          name="PhysicalAddress"
                          placeholder="Enter your display name"
                          onChange={onChange}
                          value={formValue?.PhysicalAddress?.AddressLine2 ?? ''}
                        />

                        {validateError.AddressLine2 && (
                          <span className="text-danger">{validateError.AddressLine2}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="name">
                          City
                        </label>
                        <input
                          type="text"
                          className="form-control primary_inp"
                          id="City"
                          name="PhysicalAddress"
                          placeholder="Enter your City"
                          onChange={onChange}
                          value={formValue?.PhysicalAddress?.City ?? ''}
                        />

                        {validateError.City && (
                          <span className="text-danger">{validateError.City}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="name">
                          State
                        </label>
                        <input
                          type="text"
                          className="form-control primary_inp"
                          id="State"
                          name="PhysicalAddress"
                          placeholder="Enter your State"
                          onChange={onChange}
                          value={formValue?.PhysicalAddress?.State ?? ''}
                        />

                        {validateError.State && (
                          <span className="text-danger">{validateError.State}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="name">
                          Country
                        </label>
                        <input
                          type="text"
                          className="form-control primary_inp"
                          id="Country"
                          name="PhysicalAddress"
                          placeholder="Enter your Country"
                          onChange={onChange}
                          value={formValue?.PhysicalAddress?.Country ?? ''}
                        />

                        {validateError.Country && (
                          <span className="text-danger">{validateError.Country}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <label className="primary_label" htmlFor="name">
                          Zip Code
                        </label>
                        <input
                          type="text"
                          className="form-control primary_inp"
                          id="ZipCode"
                          name="PhysicalAddress"
                          placeholder="Enter your ZipCode"
                          onChange={onChange}
                          value={formValue?.PhysicalAddress?.ZipCode ?? ''}
                        />

                        {validateError.ZipCode && (
                          <span className="text-danger">{validateError.ZipCode}</span>
                        )}
                      </div>
                    </div>
                  </div>
                }

                {
                  formValue?.type == "BioMetric" &&
                  <div>
                    BioMetric {formValue?.Verification?.BioMetric=="pending"?"(Waiting for Approval)": isEmpty(formValue?.Verification?.BioMetric) ? "" : `(${FirstCaps(formValue?.Verification?.BioMetric)})`}
                    <GridItem xs={12} sm={3} md={3}>
                      <div className="holder">
                        <div className="profile_edit_panel">
                          <img
                            src={(typeof (formValue?.BioMetric?.NationalId) == 'string') ? (formValue?.BioMetric?.NationalId == '' ? Profile : config.Back_URL + '/kyc/' + user?._id + '/' + formValue?.BioMetric?.NationalId) : (typeof (formValue?.BioMetric?.NationalId) == 'object' ? ImgUrl(formValue?.BioMetric?.NationalId) : Profile)}
                            alt="logo"
                            id="imgPreview"
                            className="img-fluid"
                          />

                          <div className="profile_edit_icon">
                            <i className="fas fa-pencil-alt"></i>
                          </div>
                          <input
                            type="file"
                            name="photo"
                            id="NationalId"
                            required="true"
                            className="photo"
                            onChange={(e) => handleFile(e)}
                          />
                          {validateError.NationalId && (
                            <span className="text-danger">{validateError.NationalId}</span>
                          )}
                        </div>
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={3} md={3}>
                      <div className="holder">
                        <div className="profile_edit_panel">
                          <img
                            src={(typeof (formValue?.BioMetric?.AddressProof) == 'string') ? (formValue?.BioMetric?.AddressProof == '' ? Profile : config.Back_URL + '/kyc/' + user?._id + '/' + formValue?.BioMetric?.AddressProof) : (typeof (formValue?.BioMetric?.AddressProof) == 'object' ? ImgUrl(formValue?.BioMetric?.AddressProof) : Profile)}
                            alt="logo"
                            id="imgPreview"
                            className="img-fluid"
                          />

                          <div className="profile_edit_icon">
                            <i className="fas fa-pencil-alt"></i>
                          </div>
                          <input
                            type="file"
                            name="photo"
                            id="AddressProof"
                            required="true"
                            className="photo"
                            onChange={(e) => handleFile(e)}
                          />
                          {validateError.AddressProof && (
                            <span className="text-danger">{validateError.AddressProof}</span>
                          )}
                        </div>
                      </div>
                    </GridItem>
                  </div>
                }


                <div className="mt-3">
                  {
                    formValue?.[formValue?.type]?.BioMetric == 'approved' ?
                    <Button className="create_btn" disabled={true}>
                      Approved
                    </Button>
                    :
                    <>
                    {disablebtn === 0 && (
                    <Button className="create_btn" onClick={handleFormSubmit}>
                      Update Profile
                    </Button>
                  )}
                  {disablebtn === 1 && (
                    <Button className="create_btn" disabled="true">
                      Form Error
                    </Button>
                  )}
                    </>
                  }
                  
                </div>
              </form>
            </GridItem>
          </GridContainer>
        </div>
      </div>
      <Footer />
    </div>
  );
}
